import { Component } from '@angular/core';

@Component({
  selector: 'app-touch-id',
  templateUrl: './touch-id.component.html',
  styleUrls: ['./touch-id.component.scss']
})
export class TouchIdComponent {

}
